"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createRelativePath_1 = __importDefault(require("./createRelativePath"));
exports.default = (function (config, status) {
    var _a = __read((config.url || '').split('?'), 2), dirPath = _a[0], query = _a[1];
    var relativePath = createRelativePath_1.default(dirPath, config.baseURL);
    var params = new URLSearchParams(query);
    Object.keys(config.params || {}).forEach(function (key) { return params.append(key, config.params[key]); });
    var searchString = params.toString();
    return "[mock] " + config.method + ": " + relativePath + (searchString === '' ? '' : "?" + searchString) + " => " + status;
});
//# sourceMappingURL=createLogString.js.map